<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="name-container">
        <label for="name-input">{{
            `${translationKeyPrefix}.wizardForm.nameInputLabel` | translate
        }}</label>
        <input
            #inputName
            type="text"
            id="name-input"
            class="form-control name-input"
            [formControlName]="formControlName"
            (blur)="onBlur()"
            (keydown.enter)="onBlur()"
        />
    </div>
    <div *ngIf="isInOrganizationContext" class="organization-group-container">
        <label for="organization-group-select">
            {{ 'project.components.wizardForm.organizationGroup' | translate }}
        </label>
        <select
            id="organization-group-select"
            class="form-select"
            formControlName="groupId"
        >
            <option [ngValue]="null">
                {{
                    'project.components.wizardForm.noOrganizationGroup'
                        | translate
                }}
            </option>
            <option *ngFor="let group of organizationGroups" [value]="group.id">
                {{ group.name }}
            </option>
        </select>
    </div>
    <div class="errors-container">
        <app-display-errors
            [control]="nameControl"
            [translationKey]="`${translationKeyPrefix}.wizardSlide`"
        >
        </app-display-errors>
    </div>
    <div class="d-flex justify-content-center create-project-button-wrapper">
        <button
            type="submit"
            class="btn btn-tryb-blue btn-create-project"
            [disabled]="form.invalid"
        >
            {{ submitButtonTxt }}
        </button>
    </div>
</form>
